import { useMemo } from 'react';
import { useGetPermissionsConfigQuery } from '@/modules/users/usersApi';
import { useGetUserDetailQuery } from '@/modules/user/userApi';
import { useAppSelector } from '@/store/hooks';
import { hasModuleAccess } from '@/utils/permissions';
import { getStaffRoleLabel } from '@/utils/user';

export function useDashboardAccess() {
  const authUser = useAppSelector((store) => store.auth.user);
  const { data: userDetail } = useGetUserDetailQuery();
  const { data: permissionsConfig } = useGetPermissionsConfigQuery();

  const user = userDetail ?? authUser;
  const teamRoles = useMemo(
    () => permissionsConfig?.customProfiles ?? [],
    [permissionsConfig?.customProfiles],
  );

  return useMemo(() => {
    const canViewOrders = hasModuleAccess(user, 'orders');
    const canViewCustomers = hasModuleAccess(user, 'customers');
    const canViewProducts = hasModuleAccess(user, 'products');
    const canViewInventory = hasModuleAccess(user, 'inventory');
    const canViewReports = hasModuleAccess(user, 'reports');

    const canViewSales =
      canViewOrders || canViewReports || hasModuleAccess(user, 'coupons');

    const roleLabel = getStaffRoleLabel(
      {
        role: user?.role,
        accessProfileId: user?.accessProfileId,
      },
      teamRoles,
    );

    const hasVisibleWidgets =
      canViewSales ||
      canViewCustomers ||
      canViewProducts ||
      canViewInventory;

    return {
      user,
      roleLabel,
      canViewOrders,
      canViewCustomers,
      canViewProducts,
      canViewInventory,
      canViewReports,
      canViewSales,
      hasVisibleWidgets,
    };
  }, [teamRoles, user]);
}
